import { ComponentIds, ValidationResultFail, } from "@inter-ikea-core/core";
import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
import { getStabilityZones, getUnstableZones } from "../functions/stability";
export class StabilityZoneValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.name = "StabilityZoneValidation";
        this.id = "STABILITY_ZONE_VALIDATION";
        this.getMessage = (stabilityZones) => {
            if (getUnstableZones(stabilityZones).length === 0) {
                return "The section is stable";
            }
            else {
                return `The section is not stable due to: ${getUnstableZones(stabilityZones).map(({ min, max, requiredPoints, points }) => `Zone | min: ${min} max: ${max} requiredPoints: ${requiredPoints} | TotalStabilityPoints:${points}`)}`;
            }
        };
        this.getProductRef = (entity) => {
            var _a;
            return (_a = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.productRef;
        };
    }
    validateCurrentState(entity) {
        if (!entity.hasComponent(COMPONENT_IDS.SECTION_COMPONENT))
            return null;
        const stabilityZones = getStabilityZones(entity);
        if (stabilityZones.stable)
            return null;
        return new ValidationResultFail(this.getMessage(stabilityZones), this.getProductRef(entity), this);
    }
    validateSnap(_Snap) {
        return null;
    }
}
